'use client';

import { useCallback, useMemo } from 'react';
import { CLIENT_ID_QUERY_KEY } from '@/consts/const';
import { useSearchQuery } from '@/hooks/useSearchQuery';
import {
  SHARE_CARD_DETAILS_FORM_TYPE_QUERY_KEY,
  SHARE_CARD_DETAILS_MODAL_OPEN,
} from '../../../../consts/client-detail';
import { ShareViaEmailModal } from './ShareViaEmailModal';
import type { ShareViaEmailModalWithUrlStateProps } from './types';

export function ShareViaEmailModalWithUrlState({
  onPendingStatusAfterProfileShare,
}: ShareViaEmailModalWithUrlStateProps) {
  const [query, updateQuery] = useSearchQuery();

  const clientId = useMemo(() => {
    const raw = query.get(CLIENT_ID_QUERY_KEY);
    return raw ? Number(raw) : null;
  }, [query]);

  const isOpen = query.get(SHARE_CARD_DETAILS_MODAL_OPEN) === 'true';

  const handleClose = useCallback(() => {
    updateQuery({
      [SHARE_CARD_DETAILS_FORM_TYPE_QUERY_KEY]: null,
      [SHARE_CARD_DETAILS_MODAL_OPEN]: null,
    });
  }, [updateQuery]);

  if (!clientId || !isOpen) {
    return null;
  }

  return (
    <ShareViaEmailModal
      key={clientId}
      isOpen
      onClose={handleClose}
      clientId={clientId}
      useTargetClientIdForProfilePendingStatus={false}
      onPendingStatusAfterProfileShare={onPendingStatusAfterProfileShare}
    />
  );
}
